<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_xi"></a><a id="dedica"></a><em>To Katherina<br/>and to the memory of my mother</em></p>
<p class="noindent"><a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedica.vue?de708088